import { useEffect, useRef, useState } from "react";
import { Button, Label, TextInput } from "flowbite-react";
import { array, object, string, boolean, date, ref } from "yup";
import { useFormik } from "formik";
import { travServicesList } from "../../services/utils/travServicesList/services";
import { travNeedsList } from "../../services/utils/travNeedsList/needs";
import UnvalidToast from "../toasts/UnvalidToast";
import { exchangeElementsOfRes, exchangeElementsOfTrav } from "../../pages/myExchangeElements/MyExchangeElements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons/faPen";
import { editTrocOfTrav } from "../../services/callAPI/toTravelerTrocs";
import ValidToast from "../toasts/ValidToast";
import "./EditTroc.css";
import { resServicesList } from "../../services/utils/resServicesList/servicesList";
import { resNeedsList } from "../../services/utils/resNeedsList/needsList";
import { editTrocOfRes } from "../../services/callAPI/toResidentsTrocs";
import { isSanitizeValue } from "../../services/hooks/sanitizeValue/isSanitizeValue";
import { cleanInputValue } from "../../services/hooks/sanitizeValue/cleanInputValue";
import { isPhoneNumberDetected } from "../../services/hooks/sanitizeValue/is-phone-number-detected";
import { cleanTitleValue } from "../../services/hooks/sanitizeValue/cleanTitleValue";
import { isSanitizeDescripValue } from "../../services/hooks/sanitizeValue/isSanitizeDescipValue";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { regionsAndDpt } from "../../services/utils/regions/regionsAndDept";


interface IEditTrocProps {
  troc: exchangeElementsOfTrav | exchangeElementsOfRes;
  triggerUseffect2: boolean;
  userRole: string | null;
  setTriggerUseEffect2: React.Dispatch<React.SetStateAction<boolean>>;
}

function EditTroc(props: IEditTrocProps) {
  //destructuring
  const { troc, triggerUseffect2, userRole, setTriggerUseEffect2 } = props;
  
  const [openModal, setOpenModal] = useState(false);

  const [_services, setServices] = useState<string[]>(["", "", ""]); // Contient les sélections des 3 champs

  const [_needs, setNeeds] = useState<string[]>(["", "", ""]); // Contient les sélections des 3 champs

  const [showDropdownServices, setShowDropdownServices] = useState<boolean[]>([false, false, false]); // Contrôle l'affichage des listes

  const [showDropdownNeeds, setShowDropdownNeeds] = useState<boolean[]>([false, false, false]); // Contrôle l'affichage des listes

  const [currentDropdownService, setCurrentDropdownService] = useState<number | null>(null);

  const [currentDropdownNeeds, setCurrentDropdownNeeds] = useState<number | null>(null);

  const [validToast, setvalidToast] = useState<boolean>(false);

  const [unvalidToast, setUnvalidToast] = useState<boolean>(false);

  const dropdownRefsService = useRef<(HTMLUListElement | null)[]>([]);

  const dropdownRefsNeeds = useRef<(HTMLUListElement | null)[]>([]);

  const userRegion = useSelector((state: RootState) => state.user.region);

  //define maxDate of 30 days after current date
  const today = new Date();

  const maxDate = new Date(today);

  maxDate.setDate(today.getDate() + 30);

  function formatedServicesName(services: string[]) {
    // Filtrer les éléments null ou undefined avant d'appliquer replace
    return services
      .filter(service => service !== null && service !== undefined)
      .map(service => service.replace(/_/g, " "));
  }

  function formatedNeedsName(needs: string[]) {
    // Filtrer les éléments null ou undefined avant d'appliquer replace
    return needs
      .filter(need => need !== null && need !== undefined)
      .map(need => need.replace(/_/g, " "));
  }

  function resetFormik() {
    resetForm()
  }

  function resetLocalVariable() {
    setShowDropdownServices([false, false, false]);
    setShowDropdownNeeds([false, false, false]);
  }

  function onCloseModal() {
    setOpenModal(false);//close modal
  }

  function onOpenModal() {
    setOpenModal(true);
  }

  const handleSelectServices = (index: number, value: string) => {
    const updatedInputs = [...values.services];
    updatedInputs[index] = value;
    setFieldValue("services", [...updatedInputs]);
    setServices(updatedInputs); //redefine services

    const updatedDropdown = [...showDropdownServices];
    updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
    setShowDropdownServices(updatedDropdown);
    setCurrentDropdownService(null); // Réinitialiser le dropdown actuellement ouvert
  };

  const handleSelectNeeds = (index: number, value: string) => {
    const updatedInputs = [...values.needs];
    updatedInputs[index] = value;
    setFieldValue("needs", updatedInputs);
    setNeeds(updatedInputs); //redefine needs

    const updatedDropdown = [...showDropdownNeeds];
    updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
    setShowDropdownNeeds(updatedDropdown);
    setCurrentDropdownNeeds(null); // Réinitialiser le dropdown actuellement ouvert
  };

  const toggleDropdownServices = (index: number) => {
    //reset content all showDropdownServices to false
    const dropdownReset = showDropdownServices.map(() => false);

    dropdownReset[index] = !showDropdownServices[index]; // inverse state (open/close)
    setShowDropdownServices(dropdownReset);
  };

  const toggleDropdownNeeds = (index: number) => {
    //reset content all showDropdownNeeds to false
    const dropdownReset = showDropdownNeeds.map(() => false);

    dropdownReset[index] = !showDropdownNeeds[index];  // inverse state (open/close)
    setShowDropdownNeeds(dropdownReset);
  };

  //formated date and time
  function formatedDate(input: string) {
    // Si la valeur d'entrée est déjà dans le bon format
    if (!input) return '';

    const [datePart, timePart] = input.split(' ');  // Diviser la date et l'heure
    const [day, month, year] = datePart.split('-');  // Diviser la date en jour, mois, année

    // Formater la date en format compatible datetime-local (YYYY-MM-DDTHH:MM)
    const formattedDate = `20${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${timePart}`;
    return formattedDate;
  }

  //formated date and time
  let dateStartFormated = formatedDate(troc.start_time);
  let dateEndFormated = formatedDate(troc.end_time);

  //set validation schema with Yup
  const dataFormSchema = object({
    role: string()
      .oneOf(["RESIDENT", "TRAVELER"], "Rôle invalide")
      .required(),
    title: string()
      .trim()
      .transform((value) => value.replace(/\s+/g, ' ').trim())
      .min(5, "Le titre doit comporter au moins 5 caractères")
      .max(50, "Le titre ne peut pas dépasser 50 caractères")
      .test("is-title-valid", "Le titre contient des caractères non-imprimables ou interdites", (value) => isSanitizeValue(value))
      .required("donner un titre"),
    services: array()
      .test("is-not-empty", "Renseigner au moins un service", (value) => {
        return value?.some((item) => !!item) ?? false
      })
      .max(3, "3 services maximum")
      .of(string().oneOf([...travServicesList, ...resServicesList], "Service invalide")),
    needs: array()
      .test("is-not-empty", "Renseigner au moins un besoin", (value) => {
        return value?.some((item) => !!item) ?? false
      })
      .max(3, "3 besoins maximum")
      .of(string().oneOf([...travNeedsList, ...resNeedsList], "Besoin invalide")),
    departement: string()
      .when('role', {
        is: "RESIDENT",
        then: (schema) => schema.required("département manquant"),
        otherwise: (schema) => schema.notRequired(),
      }),
    flexible: boolean(),
    start_time: date()
      .required("indiquez la date de début"),
    end_time: date()
      .min(ref("start_time"), "La date de fin doit être après la date de début")
      .required("indiquez la date de fin"),
    description: string()
      .min(5, "5 caractères minimum")
      .max(750, "750 caractères maximum")
      .test('no-phone', 'La description ne doit pas contenir de numéro de téléphone', isPhoneNumberDetected)
      .test("is-description-valid", "La description contient des caractères non-imprimables ou interdits", (value) => isSanitizeDescripValue(value))
      .required("précisez ce que vous offrez et ce dont vous avez besoin")
  });

  //set formik
  const { handleSubmit, handleChange, errors, isValid, touched, isSubmitting, values, setFieldValue, resetForm } = useFormik({
    initialValues: {
      role: userRole,
      title: troc.title,
      services: [...formatedServicesName(troc.matchedServices)],
      needs: [...formatedNeedsName(troc.matchedNeeds)],
      flexible: troc.flexible,
      start_time: dateStartFormated,
      end_time: dateEndFormated,
      description: troc.description,
      departement: troc.departement
    },
    validationSchema: dataFormSchema,
    validateOnChange: true,
    onSubmit: async values => {
      try {
        if (isValid) {
          //filter services and needs for api by removing empty indexes
          let filteredServices = values.services.filter((service) => service);
          let filteredNeeds = values.needs.filter((need) => need);

          //replace spaces by underscores into filteredServices and filteredNeeds
          filteredServices = filteredServices.map((service) => service?.replace(/ /g, "_"));
          filteredNeeds = filteredNeeds.map((need) => need?.replace(/ /g, "_"));

          let status;

          switch (userRole) {
            case "TRAVELER":
              status = await editTrocOfTrav(troc.id, { ...values, services: filteredServices, needs: filteredNeeds });
              break;
            case "RESIDENT":
              status = await editTrocOfRes(troc.id, { ...values, services: filteredServices, needs: filteredNeeds });
              break;
            default:
              status = null;
          }

          if (status === 200) {
            resetForm({ values: { role: values.role, title: values.title, services: values.services, needs: values.needs, start_time: values.start_time, end_time: values.end_time, flexible: values.flexible, description: values.description, departement: values.departement } })

            //close modal
            onCloseModal();

            //show valid toast
            setvalidToast(true);

            //update table via setTriggerUseEffect2
            setTriggerUseEffect2(!triggerUseffect2);
          }
          else {
            throw new Error(`Une erreur est survenue`);
          }
        }
      }
      catch (error) {
        //redifine showErrorOccurred
        setUnvalidToast(true);

        resetFormik();

        resetLocalVariable();
      }
      finally {
        //close form
        onCloseModal();
      }
    }
  })

  // Gérer le clic à l'extérieur pour fermer le dropdown
  useEffect(() => {

    const handleClickOutside = (event: MouseEvent) => {

      dropdownRefsService.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target as Node)) {
          const updatedDropdown = [...showDropdownServices];
          updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
          setShowDropdownServices(updatedDropdown);

          if (currentDropdownService === index) {
            setCurrentDropdownService(null); // Réinitialiser l'état si le dropdown actuel est fermé
          }
        }
      });

      dropdownRefsNeeds.current.forEach((ref, index) => {
        if (ref && !ref.contains(event.target as Node)) {
          const updatedDropdown = [...showDropdownNeeds];
          updatedDropdown[index] = false; // Fermer le menu déroulant après sélection
          setShowDropdownNeeds(updatedDropdown);

          if (currentDropdownNeeds === index) {
            setCurrentDropdownNeeds(null); // Réinitialiser l'état si le dropdown actuel est fermé
          }
        }
      })
    };

    document.addEventListener("mousedown", handleClickOutside); // Écouteur d'événements pour le clic

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Nettoyage
    };
  }, []);

  return (
    <>
      {unvalidToast && <UnvalidToast message="Troc non modifié. Rééssayez plus tard !" onClose={() => setUnvalidToast(false)} />}
      {validToast && <ValidToast onClose={() => setvalidToast(false)} />}

      <Button
        id="btn-edit-troc"
        className="flex items-center text-gray-700 hover:bg-gray-100"
        onClick={onOpenModal}
      >
        <FontAwesomeIcon icon={faPen} />
      </Button>

      {openModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-2"
          onClick={onCloseModal}
        >
          <div
            className="w-full max-w-2xl bg-gray-300 rounded-2xl overflow-y-auto max-h-[90vh] p-4 relative"
            onClick={(e) => e.stopPropagation()} // empêche la fermeture quand on clique à l'intérieur
          >
            {/* HEADER personnalisé */}
            <div className="flex justify-end">
              <button
                onClick={() => {
                  resetFormik();
                  resetLocalVariable();
                  onCloseModal();
                }}
                className="absolute top-2 right-2 text-[#540B0E] hover:text-red-800 font-bold text-xl"
                aria-label="Fermer"
              >
                ✖
              </button>
            </div>

            {/* FORM */}
            <form
              onSubmit={handleSubmit}
              noValidate={true}
              className="div-form flex flex-col gap-3 my-6"
            >

              {/* insert title */}
              <div id="div-title-form">

                <div className="mb-2 block">
                  <Label className="font-bold" htmlFor="title-form-modal" value="Titre" />
                </div>

                <TextInput
                  id="title-form-modal"
                  name="title"
                  type="text"
                  placeholder="name@company.com"
                  value={values.title}
                  onChange={(e) => {
                    const cleaned = cleanTitleValue(e.target.value);
                    setFieldValue("title", cleaned);
                  }}
                  required
                />
                {touched.title && errors.title && <span className="text-center text-red-500 text-sm">{errors.title}</span>}

              </div>

              {/* services and needs */}
              <div id="div-services-needs-form" className="flex flex-col gap-2">

                {/* insert services */}
                <div id="div-services-form">

                  <div className=" text-center mb-2 block">
                    <Label className="font-bold" htmlFor="services-form-modal" value="Je propose" />
                  </div>

                  <div id="grp-services" className="flex flex-col items-center space-y-4">
                    {[0, 1, 2].map((index) => (
                      <div key={index} className="relative w-64">
                        <button
                          type="button"
                          onClick={() => toggleDropdownServices(index)}
                          className="block w-full mt-1 rounded-md border border-gray-300 bg-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2 text-left"
                        >
                          <input
                            name={`services[${index}]`}
                            readOnly
                            className="w-full border-none focus:outline-none hover:cursor-pointer text-center"
                            onChange={handleChange}
                            value={values.services[index] || ""}
                          />
                        </button>

                        {showDropdownServices[index] && (
                          <ul id="ul-services" ref={(el) => (dropdownRefsService.current[index] = el)} className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {/* Option "Aucun service" */}
                            <li
                              key="none"
                              onClick={() => handleSelectServices(index, "")}
                              className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white text-lightRedCustom font-medium"
                            >
                              Aucun service
                            </li>

                            {/* services list */}
                            {userRole === "TRAVELER" ? travServicesList.map((service, itemIndex) => (
                              <li
                                key={itemIndex}
                                onClick={() => handleSelectServices(index, service)}
                                className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                              >
                                {service}
                              </li>
                            )) :
                              resServicesList.map((service, itemIndex) => (
                                <li
                                  key={itemIndex}
                                  onClick={() => handleSelectServices(index, service)}
                                  className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                                >
                                  {service}
                                </li>
                              ))
                            }
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>

                  {touched.services && errors.services && <span className="text-red-500 text-sm">{errors.services}</span>}
                </div>

                {/* insert needs */}
                <div id="div-needs-form">

                  <div className="text-center mb-2 block">
                    <Label className="font-bold" htmlFor="needs-form-modal" value="J'ai besoin de" />
                  </div>

                  <div id="grp-needs" className="flex flex-col items-center space-y-4">
                    {[0, 1, 2].map((index) => (
                      <div key={index} className="relative w-64">
                        <button
                          type="button"
                          onClick={() => toggleDropdownNeeds(index)}
                          className="block w-full mt-1 rounded-md border border-gray-300 bg-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-2 text-left"
                        >
                          <input
                            name={`needs[${index}]`}
                            readOnly
                            className="w-full border-none focus:outline-none hover:cursor-pointer text-center"
                            onChange={handleChange}
                            value={values.needs[index] || ""}
                          />
                        </button>

                        {showDropdownNeeds[index] && (
                          <ul id="ul-needs" ref={(el) => (dropdownRefsNeeds.current[index] = el)} className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {/* Option "Aucun besoin" */}
                            <li
                              key="none"
                              onClick={() => handleSelectNeeds(index, "")}
                              className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white text-lightRedCustom font-medium"
                            >
                              Aucun besoin
                            </li>

                            {userRole === "TRAVELER" ? travNeedsList.map((need, itemIndex) => (
                              <li
                                key={itemIndex}
                                onClick={() => handleSelectNeeds(index, need)}
                                className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                              >
                                {need}
                              </li>
                            )) :
                              resNeedsList.map((need, itemIndex) => (
                                <li
                                  key={itemIndex}
                                  onClick={() => handleSelectNeeds(index, need)}
                                  className="text-center cursor-pointer select-none px-4 py-2 hover:bg-indigo-600 hover:text-white"
                                >
                                  {need}
                                </li>
                              ))
                            }
                          </ul>
                        )}
                      </div>
                    ))}

                  </div>

                  {touched.needs && errors.needs && <span className="text-red-500 text-sm">{errors.needs}</span>}
                </div>

              </div>

              {/* insert troc place */}
              {userRole === "RESIDENT" && (
                <div id="div-place" className="flex flex-col items-center gap-2">
                  <label className="font-bold text-center" htmlFor="place">Lieu</label>

                  <select
                    id="select-dpt"
                    name="departement"
                    className="w-1/2"
                    value={values.departement??""}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      -- Choisis un département --
                    </option>

                    {regionsAndDpt
                      .find((region) => region.nom === userRegion)
                      ?.departements.map((dpt, index) => (
                        <option
                          key={index}
                          value={dpt.nom}
                        >
                          {dpt.nom}
                        </option>
                      ))
                    }
                  </select>
                  {touched.departement && errors.departement && <span className="text-center text-red-500 text-sm">{errors.departement}</span>}
                </div>
              )}

              {/* insert flexible and date */}
              <div className="flex flex-col" id="troc-time">

                {/* date start and end */}
                <div className="flex flex-col gap-4 justify-around" id="start-end-time">

                  {/* date start */}
                  <div className="flex flex-col items-center" id="start">
                    <label className="text-center font-bold" htmlFor="start-time">Début :</label>
                    {<input
                      name="start_time"
                      onChange={handleChange}
                      type="datetime-local"
                      min={new Date().toISOString().slice(0, 16)}
                      max={maxDate.toISOString().slice(0, 16)}
                      value={values.start_time}
                    />}
                    {touched.start_time && errors.start_time && <span className="text-red-500 text-sm">{errors.start_time}</span>}
                  </div>

                  {/* date end */}
                  <div className="flex flex-col items-center" id="end">
                    <label className="text-center font-bold" htmlFor="end-time">Fin :</label>
                    <input
                      name="end_time"
                      onChange={handleChange}
                      type="datetime-local"
                      min={new Date().toISOString().slice(0, 16)}
                      max={maxDate.toISOString().slice(0, 16)}
                      value={values.end_time}
                    />
                    {touched.end_time && errors.end_time && <span className="text-red-500 text-sm">{errors.end_time}</span>}
                  </div>

                </div>

                {/* flexible */}
                <div className="flex items-center gap-2 mt-1" >

                  <label htmlFor="flexible-checkbox">Flexible</label>

                  <input
                    className="text-greenCustom"
                    id="flexible-checkbox"
                    type="checkbox"
                    name="flexible"
                    onChange={handleChange}
                    checked={values.flexible}
                  />
                </div>

              </div>

              {/* insert description */}
              <div className="flex flex-col gap-3" id="description">

                <label className="font-bold text-center" htmlFor="description">Précision</label>

                <textarea
                  className="rounded-md bg-white p-2"
                  name="description"
                  onChange={(e) => {
                    const cleaned = cleanInputValue(e.target.value);
                    setFieldValue("description", cleaned);
                  }}
                  rows={3}
                  value={values.description}
                />

                {touched.description && errors.description && <span className="text-red-500 text-sm">{errors.description}</span>}

              </div>

              {/*buttons back and edit */}
              <div className="flex justify-between" id="btn-close-and-submit">

                <button style={{ backgroundColor: '#540B0E', color: 'white' }} className="w-2/6 font-semibold rounded-md py-2" type="button" onClick={() => { resetFormik(), resetLocalVariable(), onCloseModal() }}>Annuler</button>

                <button style={{ backgroundColor: '#335C67', color: 'white' }} className="w-2/6 font-semibold rounded-md py-2" id="btn-submit" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Envoie en cours..." : "Modifier"}
                </button>

              </div>

            </form>
          </div>
        </div>
      )}
    </>
  )
}
export default EditTroc;